import { MessageCircle } from "lucide-react";
import { whatsappLink } from "../lib/constants";

interface WhatsAppCtaProps {
  message: string;
  children: React.ReactNode;
  variant?: "solid" | "outline";
}

export function WhatsAppCta({ message, children, variant = "solid" }: WhatsAppCtaProps) {
  const base =
    "inline-flex items-center gap-2 rounded-lg border-2 border-ink px-6 py-3 text-sm font-bold transition hover:-translate-x-0.5 hover:-translate-y-0.5 hover:shadow-solid";
  const styles =
    variant === "solid"
      ? `${base} bg-brand-600 text-white shadow-solid-sm`
      : `${base} bg-white text-ink shadow-solid-sm`;

  return (
    <a href={whatsappLink(message)} target="_blank" rel="noreferrer" className={styles}>
      <MessageCircle size={18} /> {children}
    </a>
  );
}
